<!-- Full Screen -->
<li class="nav-item my-auto">
	<a
		class="nav-link"
		(click)="onFullScreenChange()"
		role="button"
		[attr.aria-label]="expand ? 'Exit full screen' : 'Enter full screen'"
		[attr.title]="expand ? 'Exit full screen' : 'Enter full screen'"
	>
		<ng-fa-icon
			class="fa-icon align-middle d-inline-flex"
			[icon]="expand ? 'compress' : 'expand'"
			[size]="EnumNgFaSize.SizeLG"
		></ng-fa-icon>
	</a>
</li>
